import { CreateRegisterAPI } from "../../apis/userApi"
import { requestPending, AdminSuccess, requestFail } from "./registrationSlice"
import { getAllAdminUsersAction } from "../admin-dashboard-page/userAction"

export const RegisterAction = (frmDt) => async (dispatch) => {
  dispatch(requestPending())
  const data = await CreateRegisterAPI(frmDt)

  data.status === "success"
    ? dispatch(AdminSuccess(data)) && dispatch(getAllAdminUsersAction())
    : dispatch(requestFail(data))
}
